import { Skeleton } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetManyWarehouses } from 'api/warehouses/use-get-many-warehouses.ts';
import { WarehouseList } from 'components/warehouse/warehouse-list';

export const WarehousesPage = () => {
  const { data: warehouses, isLoading } = useGetManyWarehouses();
  return (
    <DefaultPageLayout>
      {!isLoading ? <WarehouseList warehouses={warehouses || []} isLoading={isLoading} /> : <Skeleton />}
    </DefaultPageLayout>
  );
};
